import { defineStore } from 'pinia'
import {ref} from 'vue'

export const useUserStore = defineStore('user', () => {
    var loggedUsername = ref('');
    var loggedRole = ref(0);
    var logged = ref(false);
    var needLog = ref(false);
    var isApple = ref(false);
    function init(){
      if(localStorage.getItem("jwt")){
        let data = localStorage.getItem("jwt");
        let dataInfo = JSON.parse(atob(data.replace('Bearer','').split('.')[1]))
        login(data,dataInfo.username,dataInfo.role);
      }
    }
    var login = (jwt,username,role)=>{
      localStorage.setItem("jwt",jwt);
      localStorage.setItem("username",username);
      localStorage.setItem("role",role);
      logged.value = true;
      loggedUsername.value = username;
      loggedRole.value = role
    }
    var logout = ()=>{
      localStorage.removeItem("jwt");
      localStorage.removeItem("username");
      localStorage.removeItem("role");
      logged.value = false;
      loggedUsername.value = '';
      loggedRole.value = 0
    }
    init();

    return { loggedUsername,loggedRole, logged, login,logout, needLog, isApple }
  })